import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

interface IContainerProps {
  active: boolean
}

export const Container = styled.div<IContainerProps>`
  width: 100%;
  padding: 16px;

  border: ${({ active }) => (active
    ? `1px solid ${theme.colors.gray900}`
    : `1px solid ${theme.colors.gray200}`)};
  border-radius: 4px;

  display: flex;
  flex-direction: column;
`

export const Label = styled.label`
  color: ${theme.colors.gray400};
  font-size: ${theme.font.sizes.small};

  margin-bottom: 8px;
`

export const Counter = styled.span`
  align-self: flex-end;

  color: ${theme.colors.gray400};
  font-size: ${theme.font.sizes.xsmall};
`

export const TextArea = styled.textarea`
  width: 100%;
  height: 120px;

  border: none;
  resize: none;

  font-size: ${theme.font.sizes.normal};
`
